import { render, staticRenderFns } from "./View-Shared-Doc.vue?vue&type=template&id=565fcff2&scoped=true&"
import script from "./View-Shared-Doc.vue?vue&type=script&lang=js&"
export * from "./View-Shared-Doc.vue?vue&type=script&lang=js&"
import style0 from "./View-Shared-Doc.vue?vue&type=style&index=0&id=565fcff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565fcff2",
  null
  
)

export default component.exports